"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();

import { useEffect, useState, type SyntheticEvent } from "react"
import { map } from "lodash"
import AccordionItem from "../AccordionItem"
import type { FAQAccordionItem } from "../constants"

interface FAQContentProps {
  section: string
  accordionItems: FAQAccordionItem[]
}

const FAQContent = ({ section, accordionItems }: FAQContentProps) => {
  const [expanded, setExpanded] = useState<number | false>(false)

  useEffect(() => {
    const hashChangeEvent = () => {
      const el = document.getElementById(decodeURI(window.location.hash.slice(1)))
      if (el) {
        const yCoordinate = el.getBoundingClientRect().top + window.scrollY
        const yOffset = -80
        window.scrollTo({
          top: yCoordinate + yOffset,
          behavior: "smooth",
        })
      }
    }
    window.addEventListener("hashchange", hashChangeEvent)
    hashChangeEvent()
    return () => window.removeEventListener("hashchange", hashChangeEvent)
  }, [])

  const handleChange =
    (panel: number, _section: string) =>
    (_event: SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false)
    }

  return (
    <div className="max-w-[779px] px-[10px]">
      {map(
        accordionItems,
        ({ accordionSummaryTypography, accordionDetailsTypography }, index) => (
          <AccordionItem
            panel={index}
            section={section}
            accordionSummaryTypography={accordionSummaryTypography}
            accordionDetailsTypography={accordionDetailsTypography}
            handleChange={handleChange}
            expanded={expanded === index}
            key={`${section}-panel-${index}`}
          />
        ),
      )}
    </div>
  )
}

export default FAQContent
